<template>
    <div>
        <v-row>
            <v-col cols="11">
                <v-card-title class="titulopagina">ASOCIAR DESPACHO DE BODEGA | ROMANA</v-card-title>
            </v-col>
            <v-col cols="1">
                <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                    <v-icon color="blue" large>help</v-icon>
                </v-alert>
            </v-col>
        </v-row>
        <modal-ayuda></modal-ayuda>
        <v-col cols="12">
            <v-row class="ml-1 mr-1" v-if="alert">
                <v-col>
                    <v-alert
                    dense
                    text
                    type="success"
                    >
                    Guardado correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-col>
            </v-row>

            <v-alert v-if="alert_2"
                    dense
                    text
                    type="info"
                    >
                    <strong>No se encontraron Despachos en Romana para la patente {{despacho_pts.patente}}!</strong> <v-btn icon class="float-right" color="orange darken-3" @click="alert_2=!alert_2"><v-icon>cancel</v-icon></v-btn>
            </v-alert>
        </v-col>
        <v-dialog
            v-model="modal_edita"
            scrollable
            max-width="800px"
        >
            <v-col cols="12">
                <v-card width="100%">
                    <v-row class="ml-1 mr-1">
                        <v-col cols="10"><h3>Modificar Despacho</h3></v-col>
                        
                        <v-col cols="2">
                            <v-btn color="blue darken-1" text @click="modal_edita = false" >
                                Cerrar
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-card-text>
                        <v-row class="ml-1 mr-1">
                            <v-col cols="6">
                                <label for="">Fecha Despacho:</label>
                                <date-picker type="datetime" :clearable="false" :confirme="true" v-model="editar_item.fecha" label="Fecha Despacho"
                                    format="DD-MM-YYYY HH:mm" :default-value="editar_item.fecha" valueType="YYYY-MM-DD HH:mm"></date-picker>
                            </v-col>
                            <v-col cols="3"><v-text-field dense v-model="editar_item.patente" label="Patente"></v-text-field></v-col>
                            <v-col cols="3">
                                <v-btn color="blue darken-1" dense dark @click="modificar_despacho">
                                    <v-icon>save</v-icon>Guardar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-dialog>
        
        <v-col cols="12">
            <v-row class="ml-1 mr-1">
                <v-col cols="6">
                    <v-card>
                        <v-row class="ml-1 mr-1">
                            <v-col><h3>Despacho Bodega</h3></v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th class="cabecera">Fecha</th>
                                            <th class="cabecera">Turno</th>
                                            <th class="cabecera">Patente</th>
                                            <th class="cabecera">Cant. Maxisacos</th>
                                            <th class="cabecera">Kilos</th>
                                            <th class="cabecera">cargar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in despachos_bodega" :key="item.id" :class="index === linea_actual ? 'linea_seleccionada' : ''">
                                            <td class="text-center">{{item.fecha | fechaCompleta}}</td>
                                            <td class="text-center">{{item.turno.nombre_turno}}</td>
                                            <td class="text-center">{{item.patente}}</td>
                                            <td class="text-center">{{item.cantidad_jumbos}}</td>
                                            <td class="text-center">{{item.peso_jumbos}}</td>
                                            <td class="text-center">
                                                <v-btn dark small fab @click="cargarDespachosRomana(item,index)" color="blue darken-1"><v-icon>refresh</v-icon></v-btn>
                                                <v-btn dark small fab @click="editar_item=item; modal_edita=true; " color="blue darken-1"><v-icon>edit</v-icon></v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="6">
                    <v-card>
                        <v-row class="ml-1 mr-1">
                                <v-col><h3>Despacho Romana</h3></v-col>
                                <v-col>
                                    <v-btn @click="guardar" color="green darken-1" class="float-right" dense dark small><v-icon>save</v-icon> Guardar</v-btn>
                                </v-col>
                        </v-row>
                        <v-row class="ml-1 mr-1">
                            <v-col>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th class="cabecera">Asociar</th>
                                            <th class="cabecera">Fecha - Hora</th>
                                            <th class="cabecera">Patente</th>
                                            <th class="cabecera">Ticket</th>
                                            <th class="cabecera">Guia</th>
                                            <th class="cabecera">Cantidad (kg)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in despachos_romana" :key="item.id">
                                            <td class="text-center">
                                                <v-checkbox
                                                    v-model="item.asociado"
                                                    label=""
                                                    color="blue darken-1"
                                                    hide-details
                                                ></v-checkbox>
                                                <v-badge color="green" :content="item.bd" ></v-badge>
                                            </td>
                                            <td class="text-center">{{item.fecha_salida | fechaCompleta}}</td>
                                            <td class="text-center">{{item.patente}}</td>
                                            <td class="text-center">{{item.ticket}} </td>
                                            <td class="text-center">{{item.guia}}</td>
                                            <td class="text-center">{{item.cantidad}}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </div>
</template>
<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import { mapState, mapMutations } from 'vuex';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        despachos_romana:[],
        despachos_bodega:[],
        despacho_pts:null,
        linea_actual:null,
        editar_item:{fecha:null,patente:null},
        alert:false,
        modal_edita:false,
        alert_2:false
    }),
    mounted(){
        this.cargarDespachosPts();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Despachos de Bodega | Romana`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se asocian los despachos de harina registrados en pantalla de "Despachos de Harina" y los del sistema de romana según su fecha de despacho, patente, ticket y guía.`},
                {   tipo:`label`,   texto:`- Para asociar despacho, luego de que carguen todos los que no se hayan asociado aún, se debe pulsar el botón indicado para esto en columna "cargar" ( insert_img_help-asignar-despacho-bodega_ic1.png?width=35 ) de tabla de la izquierda (en donde se encuentran los despachos del sistema de producción)`},
                {   tipo:`label`,   texto:`- Luego de pulsar el botón, se cargarán todos los despachos de Romana que pudieran asociarse al despacho seleccionado. Se tiene que seleccionar los despachos de Romana que correspondan (en tabla de la de derecha) y pulsar en "Guardar" ( insert_img_help-asignar-despacho-bodega_ic3.png ) para registrar esta asociación en los despachos.`},
                {   tipo:`label`,   texto:`- Adicionalmente, se puede modificar un despacho de producción en caso de que hubiera algún dato mal ingresado pulsando el botón con el icono del lápiz ( insert_img_help-asignar-despacho-bodega_ic2.png?width=35 ) en columna "cargar" de la tabla de la izquierda. Esto abrirá una ventana para esta modificación.`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },

        async cargarDespachosPts(){
            //this.mostrarLoading('Cargando Despachos Bodega Sin Asociar...');
            this.mostrarLoading({titulo:'Cargando Despachos Bodega Sin Asociar...',color:'green'})

            let url = `${this.base_url}despachos_pts/por_asociar`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.despachos_bodega = res.data.data;
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },

        async cargarDespachosRomana(item,index){
            //this.mostrarLoading('Cargando Despachos Romana...');
            this.mostrarLoading({titulo:'Cargando Despachos Romana...',color:'green'})

            this.despacho_pts = item;
            this.linea_actual = index;
            let desde = this.moment(item.fecha).subtract(1, 'days').format('YYYY-MM-DD');
            let hasta = this.moment(item.fecha).add(1,'days').format('YYYY-MM-DD');
            let url = `${this.base_url}despachos_romana/${desde}/${hasta}/${item.patente}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('despachos_encontrados',res.data);
                this.despachos_romana = res.data.data;
                if(this.despachos_romana.length == 0){
                    this.alert_2 = true;
                }
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },

        async guardar(){
            //this.mostrarLoading('Guardando...');
            this.mostrarLoading({titulo:'Guardando...',color:'green'})

            let combinaciones = [];
            let combinacionesv2 = [];
            this.despachos_romana.forEach(r => {
                if(r.asociado && (r.bd == 'v1')){
                    combinaciones.push({
                        despacho_pts_id:this.despacho_pts.id,
                        despacho_romana_id:r.id
                    });
                }
                if(r.asociado && (r.bd == 'V2')){
                    combinacionesv2.push({
                        despacho_pts_id:this.despacho_pts.id,
                        guia_romanav2_id:r.id
                    });
                }
            });
            let body = {
                despachopts_despachoromana:combinaciones,
                despachopts_romanav2:combinacionesv2
            };

            let url = `${this.base_url}despachopts_despachoromana/crear_varios`;
            await this.axios.post(url,body,this.headers).then((res)=>{
                console.log('asociación realizada',res.data);
                this.ocultarLoading();
                this.alert = true;
                this.limpiar();
                this.cargarDespachosPts();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            })
            console.log('body',body)
            console.log('despacho_bodega',this.despacho_bodega);
        },

        async modificar_despacho(){
            this.mostrarLoading({titulo:'Modificando Despacho...',color:'green'})

            let body = {};
            body.patente = this.editar_item.patente;
            body.fecha = this.editar_item.fecha;

            let url = `${this.base_url}despacho_harina/${this.editar_item.id}`;
            await this.axios.put(url,body,this.headers).then((res)=>{
                console.log('despacho modificado',res.data.data);
                this.alert = true;
                this.limpiar();
                this.ocultarLoading();
                this.modal_edita = false
                this.cargarDespachosPts();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },
        limpiar(){
            this.despacho_pts = null;
            this.linea_actual = null;
            this.despachos_romana = [];
            this.despachos_bodega = [];
            this.editar_item={fecha:null,patente:null};
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda': ModalAyudas,
    },
}
</script>
<style scoped>
    .linea_seleccionada{
        background-color:#c1c1c1;
    }
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 4px;
    }
</style>